/**
 * Teeinblue Cart Bridge
 * Bridges Teeinblue's add-to-cart with theme's cart update system
 */

import { CartUpdateEvent } from '@theme/events';

class TeeinblueCartBridge {
  constructor() {
    this.lastCartCount = this.getCurrentCartCount();
    this.init();
  }

  init() {
    // Watch for Teeinblue form submissions
    document.addEventListener('submit', (e) => {
      const form = e.target;

      // Check if this is a Teeinblue form
      if (form.classList.contains('tib-product-form') ||
          form.querySelector('[name="properties[_tib_id]"]') ||
          form.action?.includes('/cart/add')) {

        console.log('🎨 Teeinblue form submitted');

        // Wait a bit for the cart to update, then check
        setTimeout(() => this.checkCartUpdate(), 500);
        setTimeout(() => this.checkCartUpdate(), 1000);
        setTimeout(() => this.checkCartUpdate(), 1500);
      }
    });

    // Also watch for AJAX cart additions
    this.interceptFetch();

    console.log('🌉 Teeinblue Cart Bridge initialized');
  }

  getCurrentCartCount() {
    const cartBubble = document.querySelector('[data-testid="cart-drawer-trigger"] .cart-bubble__count');
    return cartBubble ? parseInt(cartBubble.textContent || '0', 10) : 0;
  }

  async checkCartUpdate() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const newCount = cart.item_count;

      console.log('🛒 Cart check - Old:', this.lastCartCount, 'New:', newCount);

      if (newCount !== this.lastCartCount) {
        const itemsAdded = newCount - this.lastCartCount;
        this.lastCartCount = newCount;

        console.log('✅ Cart updated! Items added:', itemsAdded);

        // Dispatch cart update event
        document.dispatchEvent(
          new CartUpdateEvent(
            cart,
            'teeinblue-bridge',
            {
              source: 'teeinblue',
              itemCount: itemsAdded,
            }
          )
        );
      }
    } catch (error) {
      console.error('❌ Error checking cart:', error);
    }
  }

  interceptFetch() {
    const originalFetch = window.fetch;

    window.fetch = (...args) => {
      const [url] = args;
      const urlString = typeof url === 'string' ? url : url.url;

      // Check if this is a cart add request
      if (urlString.includes('/cart/add')) {
        console.log('🌐 Intercepted cart/add fetch');

        // Call original fetch and then check cart
        return originalFetch(...args).then(response => {
          if (response.ok) {
            setTimeout(() => this.checkCartUpdate(), 300);
          }
          return response;
        });
      }

      return originalFetch(...args);
    };
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TeeinblueCartBridge();
  });
} else {
  new TeeinblueCartBridge();
}
